export const OrderStatusEnum = new Map<number, 
{ label: string; }>([
  [1, { label: "Pending"}],
  [2, { label: "In Progress"}],
  [3, { label: "Completed"}],
  [4, { label: "Cancelled"}],
]);